module.exports = __webpack_public_path__ + "static/img/13bac.dff72fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/13bac.jpg
// module id = n7YF
// module chunks = 1